import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { BrandLogo } from '../BrandLogo';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white/80 dark:bg-slate-900/80 border-t border-slate-200/70 dark:border-slate-700/60 mt-20 backdrop-blur">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 text-xl font-bold text-primary-700 dark:text-primary-300 mb-4">
              <BrandLogo size={28} className="text-primary-700 dark:text-primary-300" />
              <span className="font-display">Finance Compass</span>
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
              Clear, private calculators for budgeting, income planning, and smarter money decisions.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-4">Quick Links</h3>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors">
                Home
              </Link>
              <Link to="/about" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors">
                About
              </Link>
              <Link to="/dashboard" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors">
                Dashboard
              </Link>
              <Link to="/privacy" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/contact" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors">
                Contact
              </Link>
            </div>
          </div>

          {/* Calculators */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-4">Popular Calculators</h3>
            <div className="flex flex-col gap-2">
              <Link to="/hourly-to-salary" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors">
                Hourly to Salary
              </Link>
              <Link to="/take-home-pay" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors">
                Take-Home Pay
              </Link>
              <Link to="/cost-of-living" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors">
                Cost of Living
              </Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-4">Legal</h3>
            <div className="flex flex-col gap-2">
              <Link to="/terms" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors">
                Privacy Policy
              </Link>
              <p className="text-gray-500 dark:text-gray-500 text-xs">
                Calculations are estimates and not financial advice.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-200/70 dark:border-slate-700/60 mt-8 pt-8 text-center">
          <p className="text-gray-600 dark:text-gray-400 text-sm flex items-center justify-center gap-1">
            Made with <Heart className="w-4 h-4 text-red-500" /> for better financial decisions
          </p>
          <p className="text-gray-500 dark:text-gray-500 text-xs mt-2">
            &copy; {currentYear} Finance Compass. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
